import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { GreetingCard } from '..';
import CustomErrorBoundary from '../../ErrorHandling/CustomErrorBoundary';
import { useGlobalStateContext } from '../../context/GlobalStateContext/GlobalStateContext';
import { SIDE_NAV_MAP } from '../../layout/AppLayout/constants';
import { useQuery } from '../../utils/browser-helpers';
import { getTimeOfDayGreetings } from '../../utils/date.helpers';
import { NotificationCarousel } from '../NotificationCarousel/NotificationCarousel';
import { SmsOnboardingCompletedDialog } from '../SmsOnboardingCompletedDialog/SmsOnboardingCompletedDialog';
export const GreetingSection = () => {
    const { t: text } = useTranslation();
    const [getStartedDialogOpen, setGetStartedDialogOpen] = useState(false);
    const { globalState: { merchant, selectedDateRange }, } = useGlobalStateContext();
    const { productOnboardingStatus } = merchant || {};
    const query = useQuery();
    const navigate = useNavigate();
    const greeting = getTimeOfDayGreetings();
    const greetingProps = {
        greeting: text(greeting[0], { name: merchant?.preferredName || merchant?.name }),
        imageName: greeting[1],
        selectedDateRange: selectedDateRange,
    };
    useEffect(() => {
        setGetStartedDialogOpen(!!productOnboardingStatus && query.get('dialog') === 'onboarding-completed');
    }, [merchant, query.get('dialog')]);
    return (_jsxs(Grid, { item: true, sx: {
            flexGrow: 1,
            width: '100%',
        }, children: [_jsx(SmsOnboardingCompletedDialog, { open: getStartedDialogOpen, onClose: () => {
                    navigate(SIDE_NAV_MAP['Sales'].route);
                    setGetStartedDialogOpen(false);
                } }), _jsx(GreetingCard, { ...greetingProps }), !getStartedDialogOpen && merchant.number && (_jsx(CustomErrorBoundary, { children: _jsx(NotificationCarousel, {}) }))] }));
};
